import {EncryptedTGLinkActionTypes, EncryptedTGLinkCreateAction, EncryptedTGLinkState, encryptedTGLink} from "../../types/Encryption/encryptionTGLink";

const initialEncryptedData: encryptedTGLink = {
    link: ''
};

const initialState: EncryptedTGLinkState = {
    encryptedTGLinkData: initialEncryptedData,
    loadingencryptedTGLinkData: false,
    encryptedTGLinkDataError: null,
};

export const encryptionTGLinkReducer = (state = initialState, action: EncryptedTGLinkCreateAction): EncryptedTGLinkState => {
    switch (action.type) {
        case EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_DATA:
            return { ...state, loadingencryptedTGLinkData: true, encryptedTGLinkDataError: null, encryptedTGLinkData: initialEncryptedData };
        case EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_SUCCESS:
            return { ...state, loadingencryptedTGLinkData: false, encryptedTGLinkDataError: null, encryptedTGLinkData: action.payload };
        case EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_ERROR:
            return { ...state, loadingencryptedTGLinkData: false, encryptedTGLinkDataError: action.payload, encryptedTGLinkData: initialEncryptedData };
        default:
            return state;
    }
};